import { render, staticRenderFns } from "./BedMeshChart.vue?vue&type=template&id=c47419de&scoped=true&"
import script from "./BedMeshChart.vue?vue&type=script&lang=ts&"
export * from "./BedMeshChart.vue?vue&type=script&lang=ts&"
import style0 from "./BedMeshChart.vue?vue&type=style&index=0&id=c47419de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47419de",
  null
  
)

export default component.exports